var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 59,
    viewBox: "0 0 63 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1507 37.636L38.7257 46.2987L42.0065 50.4935C42.5338 51.1568 42.3971 52.0738 41.7526 52.6006C41.0887 53.1274 40.1708 52.9908 39.6435 52.347L37.0071 48.7765L29.5276 59.0001H60.8909L45.1507 37.636Z",
    fill: "#00F0FF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6231 22.8079C19.3872 22.8079 22.4386 19.7593 22.4386 15.9987C22.4386 12.2381 19.3872 9.18951 15.6231 9.18951C11.8589 9.18951 8.8075 12.2381 8.8075 15.9987C8.8075 19.7593 11.8589 22.8079 15.6231 22.8079Z",
    fill: "#00F0FF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.712 27.9196C22.9659 27.5294 23.4932 27.3929 23.8838 27.3929C24.411 27.3929 24.8016 27.6465 25.0555 28.0562L37.0071 43.9183L44.0961 34.3386C44.6234 33.5582 45.9318 33.5582 46.4591 34.3386L63 56.7758V0H0V57.0294L22.712 27.9196ZM15.6231 6.30192C21.013 6.30192 25.3289 10.6333 25.3289 15.9987C25.3289 21.3641 20.9935 25.6954 15.6231 25.6954C10.2526 25.6954 5.89771 21.3641 5.89771 15.9987C5.78053 10.6138 10.2331 6.30192 15.6231 6.30192Z",
    fill: "#00F0FF",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.747 31.1975L2.22626 59.0001H25.7194L35.0347 46.2792L23.747 31.1975Z",
    fill: "#00F0FF",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file_upload_icon.e9f0e6129a314260ee9550b7c547d627.svg";
export { ForwardRef as ReactComponent };